import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { VehicleFormFields } from "../_components/vehicle-form-fields";

export function CreateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:CreateVehicle");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <VehicleFormFields mode="create" />
    </CenteredLayout>
  );
}
